const overlay = document.getElementById('mobile-nav-overlay');
const openBtn = document.getElementById('mobile-nav-open');
const closeBtn = document.getElementById('mobile-nav-close');
const mainPanel = document.getElementById('mobile-nav-main');
const subPanel = document.getElementById('mobile-nav-sub');
const subTitle = document.getElementById('mobile-nav-sub-title');
const subLinks = document.getElementById('mobile-nav-sub-links');
const backBtn = document.getElementById('mobile-nav-back');

if (!overlay) throw new Error('No #mobile-nav-overlay found');

const openOverlay = () => {
	overlay.classList.add('is-open');
	document.body.style.overflow = 'hidden';
	closeBtn.focus();
};

const closeOverlay = () => {
	overlay.classList.remove('is-open');
	document.body.style.overflow = '';
	resetToMain();
	openBtn.focus();
};

const showSub = (key) => {
	const source = document.querySelector(`[data-mobile-submenu="${key}"]`);
	if (!source) return;

	subTitle.textContent = source.dataset.title;
	subLinks.innerHTML = source.innerHTML;

	mainPanel.classList.add('is-hidden');
	subPanel.classList.add('is-visible');
};

const resetToMain = () => {
	mainPanel.classList.remove('is-hidden');
	subPanel.classList.remove('is-visible');
};

openBtn.addEventListener('click', openOverlay);
closeBtn.addEventListener('click', closeOverlay);
backBtn.addEventListener('click', resetToMain);

document.querySelectorAll('.mobile-nav__item[data-submenu]').forEach(btn => {
	btn.addEventListener('click', () => showSub(btn.dataset.submenu));
});

// Close on Escape
document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
});
